export default __webpack_public_path__ + "static/media/bg18.5b5c0d28.jpg";